// hooks/useFolderSelect.ts
import { useState } from 'react';
import { useController } from 'react-hook-form';
import useGeneratorStore from '@/state/generator-store';
import { Dialog } from '@/components/Dialog';
import FolderDialog from '../components/FolderDialog';

export const useFolderSelect = () => {
  const { control, formValues, generatorForm } = useGeneratorStore((state) => ({
    control: state.control,
    formValues: state.formValues,
    generatorForm: state.generatorForm,
  }));

  const [folderName, setFolderName] = useState<string>();

  const {
    field: { onChange: onFolderIdChange },
  } = useController({
    name: 'folderId',
    control,
    defaultValue: formValues?.folderId || null,
  });

  const handleOnSelect = (selectedFolderId: number | null) => {
    generatorForm?.setValue('folderId', selectedFolderId);
    onFolderIdChange(selectedFolderId);
  };

  const showFolderDialog = () => {
    Dialog.info({
      closeClassName: 'left-auto right-4 !p-0 rounded-[4px] ',
      dialogContentClassName: 'bg-jen-content-primary-contrast h-[440px]',
      title: 'Select Folder For Your Track',
      contentJSX: ({ onClose }) => (
        <FolderDialog
          onSelect={() => {
            onClose();
          }}
          onClose={onClose}
          setFolderName={setFolderName}
          setFolderId={(id) => handleOnSelect(id as number)}
        />
      ),
    });
  };

  return {
    folderName,
    showFolderDialog,
  };
};
